import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  root: {
    maxWidth: '100%',
    padding: theme.spacing(2, 3),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2, 4)
    }
  }
}), {
  name: 'SD-DrawerContent'
});
/** @deprecated Use `<AppDrawer>` instead. */
export var DrawerContent = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles();
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: clsx(styles.root, className)
  }));
});
if (process.env.NODE_ENV !== "production") DrawerContent.displayName = "DrawerContent";